import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const navLinks = [{
    name: 'Startseite',
    path: '/'
  }, {
    name: 'Über uns',
    path: '/ueber-uns'
  }, {
    name: 'Leistungen',
    path: '/leistungen'
  }, {
    name: 'CleanCopter',
    path: '/cleancopter'
  }, {
    name: 'Karriere',
    path: '/karriere'
  }, {
    name: 'Kontakt',
    path: '/kontakt'
  }];
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm border-b border-gray-100" data-id="element-75">
      {/* Top Bar - Contact Info */}
      <div className="bg-blue-900 text-white py-2 px-4 hidden md:block" data-id="element-76">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm" data-id="element-77">
          <div className="flex items-center space-x-6" data-id="element-78">
            <a href="tel:0241512746" className="flex items-center hover:text-emerald-300 transition-colors" data-id="element-79">
              <Phone className="w-4 h-4 mr-2 text-emerald-400" data-id="element-80" />
              0241 512746
            </a>
            <a href="mailto:buero@lissowski-gmbh.de" className="flex items-center hover:text-emerald-300 transition-colors" data-id="element-81">
              <Mail className="w-4 h-4 mr-2 text-emerald-400" data-id="element-82" />
              buero@lissowski-gmbh.de
            </a>
          </div>
          <div className="flex items-center space-x-4" data-id="element-83">
            <span className="text-blue-200" data-id="element-84">Mo-Do 8-14 Uhr, Fr 8-12 Uhr</span>
            <span className="bg-emerald-500 text-white px-2 py-0.5 rounded text-xs font-bold" data-id="element-85">
              24h Notdienst
            </span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="flex justify-between items-center h-20" data-id="element-87">
          {/* Logo */}
          <Link to="/" className="flex flex-col" data-id="element-88">
            <span className="text-2xl font-bold text-blue-900 tracking-tight" data-id="element-89">
              LISSOWSKI
            </span>
            <span className="text-xs text-gray-500 font-medium tracking-widest uppercase" data-id="element-90">
              Glas- & Gebäudereinigung
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-91">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-blue-700 ${isActive(link.path) ? 'text-blue-800 font-bold' : 'text-gray-600'}`} data-id="element-92">
                {link.name}
              </Link>)}
            <Link to="/kontakt" data-id="element-93">
              <Button size="sm" variant="primary" data-id="element-94">
                Angebot anfordern
              </Button>
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-gray-600 hover:text-blue-900" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Menu" data-id="element-95">
            {isMenuOpen ? <X className="w-6 h-6" data-id="element-96" /> : <Menu className="w-6 h-6" data-id="element-97" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-lg" data-id="element-98">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-99">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-3 rounded-md text-base font-medium ${isActive(link.path) ? 'bg-blue-50 text-blue-900' : 'text-gray-700 hover:bg-gray-50 hover:text-blue-900'}`} onClick={() => setIsMenuOpen(false)} data-id="element-100">
                {link.name}
              </Link>)}
            <div className="pt-4 px-3" data-id="element-101">
              <Link to="/kontakt" onClick={() => setIsMenuOpen(false)} data-id="element-102">
                <Button fullWidth variant="primary" data-id="element-103">
                  Kostenloses Angebot
                </Button>
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}